import UserAddRequestRoute from './_config/portail.user.add.request.routes';
import userAddRequestList from './components/user-add-request-list';

const moduleName = 'app.massia.common.portail.user-add-request';

angular.module(moduleName, []).config(UserAddRequestRoute).component('portailUserAddRequestList', userAddRequestList);
export default moduleName;
